import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { DocRow } from "../SubcontractorDocs";

// Conformité (documents / assurances) rattachée à la fiche poseur de l'annuaire.
export default function PoseurCompliance({ annuaireId }) {
  const [sub, setSub] = useState(null);
  const [types, setTypes] = useState([]);
  useEffect(() => {
    Promise.all([api.get(`/subcontractors/${annuaireId}`), api.get("/subcontractors/doc-types")])
      .then(([s, t]) => { setSub(s.data); setTypes(t.data.doc_types || []); }).catch(() => setSub(null));
  }, [annuaireId]);
  if (!sub) return null;
  return (
    <div className="md:col-span-2 border-t border-norea-border pt-3 mt-1" data-testid="poseur-compliance">
      <div className="text-xs font-medium text-norea-text mb-2">Conformité : documents & assurances</div>
      <div className="space-y-2">{types.map((t) => <DocRow key={t.key} sub={sub} type={t} onUpdated={setSub} />)}</div>
    </div>
  );
}
